import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const ARTCAST_NOTIFICATIONS_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/notifications',
        iconClass: 'fas fa-bell',
        name: 'Notification',
        layout: eLayoutType.application,
        requiredPolicy: 'Artcast.Notifications',
        order: 9
      },
    ]);
  };
}
